import { PropsWithChildren } from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';
import {Link} from 'react-router-dom';
import {ROUTES} from 'routes';
import WestIcon from '@mui/icons-material/West';
import { checkMobile } from './Device';

interface HeaderProps extends TypographyProps {
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    compact?: boolean;
}

export const Header = ({ children, as = 'h1', ...rest }:PropsWithChildren & HeaderProps) => <Typography variant={as} component={as} mt={2} mb={1} { ...rest }>{children}</Typography>

export const PageTitle = ({ textAlign = 'left', compact = false, children, ...rest }: TypographyProps & { compact?: boolean; }) =>
    <Typography textAlign={textAlign} component="h1" variant={checkMobile() ? "h5" : "h4"} mb={compact ? 0 : 3} {...rest}>{children}</Typography>
    
export const ReturnHeader = ({ to, children, as="h1", variant="h3", ...rest }:PropsWithChildren & HeaderProps & { to?: string }) => (
    <Header as={as} variant={variant} { ...rest}>
        <Link to={to || ROUTES.home}>
            <WestIcon
                sx={{
                    display: 'inline',
                    verticalAlign: 'middle',
                    marginRight: '10px',
                }}
            />
        </Link>
        {children}
    </Header>
);